module.exports = __webpack_public_path__ + "img/login-bg.33f495f8.png";